// import { getWebappClassicWindow } from '@/types/classic';
import { HelperEmptyObject } from '@/types';

export default async function mushodoPromise<
  MushodoSuccess = HelperEmptyObject,
  MushodoError = HelperEmptyObject
>(
  mushodoCall: string,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  params: Record<string, any> | string = '',
  syncAll = false,
  blockGlobalEvents = false
): Promise<MushodoSuccess> {
  if (!mushodoCall) {
    throw new Error('mushudoCall is required and should be String');
  }

  return new Promise((resolve, reject) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    DP.mushodo.askSingle(
      mushodoCall,
      params,
      (s: MushodoSuccess) => resolve(s),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      (e: MushodoError): Promise['catch'] => {
        console.error(e);
        reject(e);
      },
      syncAll,
      blockGlobalEvents
    );
  });
}
